import { agentCard, applyOverrides } from '../../../shared';

export const sellersAgentCard = applyOverrides(agentCard, {
  id: 'sellerSideContacts.sellersAgent',
  innerTitle: "Landlord's Agent x",
  outerTitle: "Landlord's Agents",
  addableTitle: "Landlord's Agent x",
  addText: "Landlord's Agent",
});
